<template>
    <loader v-if="isLoading == true" name="spinning" loadingText="Cargando..." textColor="#ffffff" textSize="20" textWeight="500" object="#ff9633" color1="#ffffff" color2="#17fd3d" size="5" speed="2" bg="#343a40" objectbg="#999793" opacity="80" :disableScrolling="true"></loader>
  
      <div class="container">
      <div
    v-if="mostrarModal"
    class="modal fade show"
    style="display: block; background: rgba(0,0,0,.5);"
>
    <div class="modal-dialog">
        <div class="modal-content">

            <div class="modal-header">
                <h5 class="modal-title">
                    Editar información
                </h5>

                <button
                    type="button"
                    class="close"
                    @click="mostrarModal = false"
                >
                    <span>&times;</span>
                </button>
            </div>

            <div class="modal-body">

                <div class="form-group my-3" style="text-align: left;">
                    <label>Emitido por</label>

                    <input
                        type="text"
                        class="form-control"
                        v-model="datosInspeccion.emitido_por"
                    >
                </div>

                <div class="form-group my-3" style="text-align: left;">
                    <label>Fecha del oficio</label>

                    <input
                        type="date"
                        class="form-control"
                        v-model="datosInspeccion.fecha_oficio"
                    >
                </div>

                <div class="form-group my-3" style="text-align: left;">
                    <label>Folio de inspección</label>

                    <input
                        type="text"
                        class="form-control"
                        v-model="datosInspeccion.folio_inspeccion"
                    >
                </div>

                <div class="form-group my-3" style="text-align: left;">
                    <label>Número de oficio</label>

                    <input
                        type="text"
                        class="form-control"
                        v-model="datosInspeccion.numero_oficio"
                    >
                </div>

            </div>

            <div class="modal-footer">

                <button
                    type="button"
                    class="btn btn-secondary"
                    @click="mostrarModal = false"
                >
                    Cancelar
                </button>

                <button
                    type="button"
                    class="btn"
                    style="background-color: #F49315; color: white;"
                    @click="guardarEdicion"
                >
                    Guardar
                </button>

            </div>

        </div>
    </div>
</div>
      <hr>
        <div class="row">
          <div class="col-md-4">
              <h3>Información General
              </h3>
            <table class="table-responsive">
              <tr>
                <td>Nombre</td>
                <td>{{datos.razon_social}}</td>
              </tr>
              <tr>
                <td>RFC</td>
                <td></td>
              </tr>
              <tr>
                <td>Nombre del representante:</td>
                <td>{{datos.nombre_representante}}</td>
              </tr>
              <tr>
                <td>Correo del representante:</td>
                <td>{{datos.email}}</td>
              </tr>
              <tr>
                <td>Tipo:</td>
                <td>{{datos.tipo}}</td>
              </tr>
              <tr>
                <td>Domicilio:</td>
                <td>{{datos.domicilio}}</td>
              </tr>
              <tr>
                <td>Capacidad:</td>
                <td>{{datos.capacidad}}</td>
              </tr>
              <tr>
                <td>Voltaje de conexión:</td>
                <td>{{datos.voltaje_conexion}}</td>
              </tr>
              <tr>
                <td>CIE:</td>
                <td></td>
              </tr>
              <tr>
                <td>Asignado:</td>
                <td>{{datos.usuario}}</td>
              </tr>
              <tr>
                <td>Creador:</td>
                <td>{{datos.usuario}}</td>
              </tr>
            </table><br>
            
          </div>
          <div class="col-md-4">
              <h3>Presupuesto</h3>
            <table>
              
              <tr>
                <td>Importe</td>
                <td> {{datos.importeFormato}}</td>
              </tr>
              <tr>
                <td>Rango de Horas</td>
                <td></td>
              </tr>
              <tr>
                <td>CIE:</td>
                <td></td>
              </tr>
              
            </table>
            <!--<h3>Enviar contrato</h3>--> 
           
            
          </div>
          <br>
          <!--<div class="col-md-8">
            <div class="table-responsive">
              <h3>Datos de solicitud</h3>
            <table class="table table-bordered table-hover tabla-inspeccion">
                <thead>
                    <tr>
                        <th>Emitido por</th>
                        <th>Fecha del oficio</th>
                        <th>Folio de inspección</th>
                        <th>Número de oficio</th>
                        <th class="text-center">Acciones</th>
                    </tr>
                </thead>

                <tbody>
                  
                    <tr>
                    
                        <td>{{ datosInspeccion.emitido_por }}</td>
                        <td>{{ datosInspeccion.fecha_oficio }}</td>
                        <td>{{ datosInspeccion.folio_inspeccion }}</td>
                        <td>{{ datosInspeccion.numero_oficio }}</td>

                        <td class="text-center">
                            <button
                                type="button"
                                class="btn btn-sm btn-warning"
                                @click="editarInspeccion(inspeccion, index)"
                                title="Editar"
                            >
                                <i class="mdi mdi-pencil"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
          </div>-->
          <div class="d-flex align-items-center">
              <button type="button" class="btn" style="background-color: #F49315; color: white;" @click="generatePDF">
                <i class="mdi mdi-file-pdf mr-2"></i> <!-- Añadir margen a la derecha -->
                Contrato 
              </button> &nbsp;
              
              <!--<button type="button" class="btn btn-dark ml-2" @click="generatePDFPersonaMoral">
                  <i class="mdi mdi-file-pdf mr-2"></i> 
                  Contrato Persona Moral
              </button>-->
          </div>
          <!--<div class="col-md-4">
            <h3>Solicitud de Inspección</h3> 
  
            <button type="button" class="btn btn btn-dark" v-if="datos.solicitud_inspeccion == 0 ||
             datos.solicitud_inspeccion == null " @click="enviarSolicitud()">
                <i class="mdi mdi-pen"></i><router-link to="/solicitudinspeccion">Enviar Solicitd </router-link> 
             
            </button>
            <button type="button" class="btn btn btn-dark" v-else>
              <i class="mdi mdi-pen"></i><router-link to="/solicitudinspeccion">Ver Solicitd </router-link> 
           
            </button>
  
          </div>-->
        </div>
        <br>

        
        <!--<div class="col-md-12" style="text-align: left !important;">
          <button type="button" class="btn btn btn-dark" >
              <i class="mdi mdi-pen"></i>
              <router-link  to="/editarcotizacion" style="color: white;"><span>Editar</span></router-link>
          </button> &nbsp;
          <button type="button" class="btn btn btn-dark" >
            <i class="mdi mdi-checkbox-multiple-blank"></i>
            <router-link  to="/cotizacion" style="color: white;"><span>Cotizaciones</span></router-link>
          </button>&nbsp;
          <button type="button" class="btn btn btn-dark"  @click="generatePDF">
            <i class="mdi mdi-file-pdf"></i>
           <span>Pdf</span>
          </button>
        </div>-->
  
      </div>
    </template>
    
    <script>
    import axios from 'axios';
    import Swal from 'sweetalert2';
    
    export default {
      data() {
        return {
          isLoading:false,
          datos: [],
          nombreOficio:'',
          datosInspeccion:[],
          inspeccionEditando: {
              emitido_por: '',
              fecha_oficio: '',
              folio_inspeccion: '',
              numero_oficio: ''
          },
          indexEditando: null,
          mostrarModal: false,
        }
      },
      created() {
        this.fetchData();
      },
      methods: {
        guardarEdicion() {
          
            if (
                !this.datosInspeccion.emitido_por ||
                !this.datosInspeccion.fecha_oficio ||
                !this.datosInspeccion.folio_inspeccion ||
                !this.datosInspeccion.numero_oficio
            ) {
                Swal.fire('¡Error!', 'Todos los campos son obligatorios', 'error');
                return;
            }
            //console.log(this.$rutaServer + 'editarInspeccion');
            axios.post(this.$rutaServer+'editarInspeccion',{id:this.datosInspeccion.id,emitido_por:this.datosInspeccion.emitido_por,fecha_oficio:this.datosInspeccion.fecha_oficio,folio_inspeccion:this.datosInspeccion.folio_inspeccion,numero_oficio:this.datosInspeccion.numero_oficio})
            .then(response => {
                
                // Actualizar la tabla
                this.datosInspeccion[this.indexEditando] = {
                    ...this.inspeccionEditando
                };
                this.mostrarModal = false;
                Swal.fire('Exito!', 'Se actualizo correctamente la información', 'success');
            })
            .catch(error => {
                console.error('Error al actualizar:', error);
                Swal.fire('¡Error!', 'Ocurrió un error', 'error');
            });
        },
        editarInspeccion(inspeccion, index) {
          console.log('Registro seleccionado:', inspeccion);
          this.inspeccionEditando = {
                ...inspeccion
          };
          this.indexEditando = index;
          this.mostrarModal = true;
        },
        enviarSolicitud(){
          var id = localStorage.getItem('idcotizacion');
          axios.post(this.$rutaServer+'solicitudInspeccion', { id: id })
            .then(response => {
              if (response.status == 200) {
                Swal.fire('Exito!', 'Se genero con exito la solicitud', 'success');
               
              }
            })
            .catch(error => {
              Swal.fire('¡Error!', 'Ocurrió un error', 'error');
            });
  
        },
        downloadPDF() {
          // URL del archivo PDF en el servidor
          const pdfUrl = 'https://backsarei.seguridadeninspeccion.com/'+this.datos.oficio_cfe;
          // Crear un enlace invisible para desencadenar la descarga
         /* const link = document.createElement('a');
          link.href = pdfUrl;
          link.setAttribute('download', this.nombreOficio); // Nombre del archivo a descargar
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);*/
   // Abrir el PDF en una nueva pestaña
   window.open(pdfUrl, '_blank');
  
          
        },
         generatePDF() {
          var idcotizacion = localStorage.getItem('idcotizacion');
          axios.post(this.$rutaServer + 'generatePdfContrato', {idcotizacion:idcotizacion}, {
    responseType: 'blob'
})
.then(response => {
    if (response.status === 200) {
        // Crear un objeto Blob a partir de la respuesta
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'contrato.pdf'); // Nombre del archivo

        // Agregar y hacer clic en el enlace para iniciar la descarga
        document.body.appendChild(link);
        link.click();

        // Limpiar
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url); // Liberar la memoria utilizada por el objeto URL
    }
})
.catch(error => {
    Swal.fire('¡Error!', 'Ocurrió un error', 'error');
});
           /* fetch('http://127.0.0.1:8000/api/generatePdfContrato', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                }})
                .then(response => response.json())
                .then(data => {
                    const url = data.url;
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'contrato.pdf');
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                })
                .catch(error => console.error('Error al descargar el PDF:', error));*/
      },
      generatePDFPersonaMoral() {
          var idcotizacion = localStorage.getItem('idcotizacion');
          axios.post(this.$rutaServer + 'generatePdfContratoPersonaMoral', {idcotizacion:idcotizacion}, {
            responseType: 'blob'
          })
          .then(response => {
              if (response.status === 200) {
                  // Crear un objeto Blob a partir de la respuesta
                  const url = window.URL.createObjectURL(new Blob([response.data]));
                  const link = document.createElement('a');
                  link.href = url;
                  link.setAttribute('download', 'contratopersonamoral.pdf'); // Nombre del archivo

                  // Agregar y hacer clic en el enlace para iniciar la descarga
                  document.body.appendChild(link);
                  link.click();

                  // Limpiar
                  document.body.removeChild(link);
                  window.URL.revokeObjectURL(url); // Liberar la memoria utilizada por el objeto URL
              }
          })
          .catch(error => {
              Swal.fire('¡Error!', 'Ocurrió un error', 'error');
          });
        },
          regresar(){

          this.$router.push('/cotizacion');
          },
        fetchData() {
          this.isLoading = true;
          var id = localStorage.getItem('idcotizacion');
          axios.post(this.$rutaServer+'datosCotizacion', { id: id })
            .then(response => {
              if (response.status == 200) {
                this.isLoading = false;
                console.log(response.data.inspeccion[0]);
                this.datos = response.data.data[0];
                this.datosInspeccion = response.data.inspeccion[0];
                console.log(this.datosInspeccion);
                this.datos.importeFormato = Number(this.datos.importe).toLocaleString(
                  'es-MX',
                  {
                      style: 'currency',
                      currency: 'MXN'
                  }
              );
              
                if(this.datos.oficio_cfe){
                  var arreglo = this.datos.oficio_cfe.split('/');
                  this.nombreOficio = arreglo[2];
                }
                
                
                console.log(this.datos);
              }
            })
            .catch(error => {
              Swal.fire('¡Error!', 'Ocurrió un error', 'error');
            });
        }
      }
    }
    </script>
    
   <style scoped>
table {
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
}

table,
th,
td {
    border: 1px solid black;
}

th,
td {
    padding: 8px;
    text-align: left;
    word-break: break-word;
    overflow-wrap: anywhere;
}

.table-responsive {
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}

/* En celular */
@media (max-width: 768px) {
    .container {
        width: 100%;
        max-width: 100%;
        padding-left: 10px;
        padding-right: 10px;
    }

    .row {
        margin-left: 0;
        margin-right: 0;
    }

    .col-md-4 {
        width: 100%;
        margin-bottom: 20px;
    }

    table {
        width: 100%;
        table-layout: fixed;
    }

    td {
        word-break: break-word;
        overflow-wrap: anywhere;
        font-size: 14px;
    }

    td:first-child {
        width: 40%;
    }

    td:last-child {
        width: 60%;
    }
}
</style>
    